let config = {}
if (process.env.NODE_ENV === 'development') {
  config = {
    email: 'info@b1g1.com',
    // server: 'https://design-api.b1g1.com',
    // server: 'https://api.b1g1.com',
    server: 'http://127.0.0.1:8000',
    host: 'http://localhost:8082',
    client_id: 1,
    client_secret: 'Fo72n242PouyI7J3HfnR6uMaHcHG124zgvuUQFhX',
    grant_type: 'password',
    membership: 'U2FsdGVkX1/S5iFqbjWFPnK3B6tT6nVZ5ybBerDWzBi7aNjog3QP1kisuLV3uZA+SNS/HnSU8tTzHXMDLzq2d6cATgOwKA5+9SsqokL5N0AI8JojWkm4BqyLyShDJ/d88axiG44IcTd4gqe3CfpWhcREFwZooNWYAqqRWDX5M58=',
    giving: 'U2FsdGVkX19R+A6WopVlTs3D+7+H4hqQib1gCRWp9mxLDv1NwNq4nkOcdDXDGNxdeIt1rBdRNtJhodY1pVomf6flWYA54kFtPh5+DlVvxKiunqWP/upK2m5vCPsCnIGp/s/ITBXMBLTJhg5B7EPb6Fu++btwp6/m2A3YsySTqCQ=',
    payment_server: 'http://localhost/payment.b1g1.org',
    hotjar_id: '1947939',
    environment: 'development',
    purchase_account_amt: 30,
    restricted_countries: ['United States'],
    charity_disclosure_countries: ['United States'],
    smallest_package_name: 'Tiny',
    restricted_states: [],
    stripeKey1: 'pk_test_lB0uz4w1N5ppFYomqGJVTTcL00u8WFtt8X',
    tokenMultiplier: 100,
    stripeKey2: 'pk_test_xb8XzR8Fd4nS72UhefumZahW'
  }
} else if (process.env.NODE_ENV === 'production') {
  config = {
    email: 'info@b1g1.com',
    server: 'https://api.b1g1.com',
    host: 'https://family.b1g1.com',
    client_id: 6,
    client_secret: 'yfKa4pJgdihXhChlSYzKnGG1J7MVy2wqH8fhrX6w',
    grant_type: 'password',
    membership: 'U2FsdGVkX19visCBuqdpxOoAnRmil+5txQglsEYGED+ubgGV1tB67Ro3r7i0/sRUL46TyHMnteZa8ySL1SUHY9FBJUGLxLLn+ACTtHYPnTKVGjXyeQjRusrDjuR6a6epfduHWn1rrbz03ykwOavRphWDDB4dutzkXeHjoTOqHF8=',
    giving: 'U2FsdGVkX18BjMRnoaRxrZwG6W85QIwGwLfT+Ub5T9s17xZMavfGLw0wOu0FfCWBWso51/Ukp21pQlGpx+joaK1Av/KbJ/Glgz1u72aYrIxzqWxHuuDa1twNZc/jI6Hcfnc0N2mE5/Pr+XPXAEkPtYzmwpa5mXwPuKO8tic+QR8=',
    payment_server: 'https://b1g1.org',
    hotjar_id: '6647833',
    environment: 'production',
    smallest_package_name: 'Tiny',
    tokenMultiplier: 100,
    restricted_countries: ['United States'],
    charity_disclosure_countries: ['United States'],
    purchase_account_amt: 30,
    milestone_maximum_contribution_limit: 6
  }
}

export default config



// WEBPACK FOOTER //
// ./src/config/app.js